<template>
  <div>
    <div class="wrapper">
      <v-app-bar color="primary" flat app dark>
        <v-btn style="position: absolute" icon :to="'/'">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-app-bar-title style="min-width: fit-content;">イベントカレンダー</v-app-bar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-card tile class="overflow-hidden no-scroll-bar pb-14" elevation="0">
        <div class="d-flex mt-16 mx-3">
          <v-btn @click="toPrevMonth" variant="text" class="no-background-hover mt-3 pl-0" color="primary" dark>
            <v-icon>mdi-chevron-left</v-icon>
            <h4 class="primary--text">
              前の月
            </h4>
          </v-btn>

          <v-app-bar-title>
            <div @click="isCalendar = !isCalendar">
              <h5 class="text-center">{{ year }}年</h5>
              <div class="d-flex justify-center">
                <h3>{{ month }}</h3>
                <v-icon v-if="isCalendar" color="primary">mdi-chevron-down</v-icon>
                <v-icon v-else color="primary">mdi-chevron-up</v-icon>
              </div>
            </div>
          </v-app-bar-title>

          <v-btn @click="toNextMonth" variant="text" class="no-background-hover mt-3 pr-0" color="primary">
            <h4 class="primary--text">
              次の月
            </h4>
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </div>
        <v-expand-transition>
          <v-sheet class="" v-if="isCalendar" height="400">
            <v-calendar
              v-model="now"
              color="primary"
              :day-format="(d) => new Date(d.date).getDate().toString()"
              :month-format="(d) => new Date(d.date).getMonth() + 1 + ' /'"
              @click:day="(_event, value) => viewDay(value)"
            >
              <!-- V3ではスロットのスコープが day オブジェクトになります -->
              <template v-slot:day="{ date }">
                <div v-for="e in getEventNum(date)" :key="e.yearlyEventId" class="d-flex justify-center">
                  <div class="event_num ma-1"></div>
                </div>
              </template>
            </v-calendar>
          </v-sheet>
        </v-expand-transition>
        <div v-show="!isCalendar" class="pa-7"></div>

        <v-sheet
          id="scrolling-techniques-2"
          class="overflow-y-auto no-scroll-bar"
          max-height="100vh"
          elevation="0"
        >
          <div
            v-scroll:#scrolling-techniques-2="onScroll"
            v-for="(e, index) in events"
            :key="e.yearlyEventId + index"
            class="plan-wrapper ma-1 pa-2 px-3 d-flex"
            style="border-color: #32c5ff;"
          >
            <div class="text-center pr-5" style="width: 40px;">
              <p class="caption">{{ dayFormat(e.date) }}</p>
              <h4 class="text-no-wrap">{{ dateFormat(e.date) }}</h4>
            </div>
            <div style="white-space:pre-wrap;user-select: none;">
              <p style="line-height: 38px;">{{ e.eventName }}</p>
            </div>
            <v-spacer />
            <!-- <div
            v-for="child in e.children"
            :key="child.childId"
          >
            <div class="icon mr-2">
              <img
                :src="child.imageUrl? child.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'"
              >
            </div>
          </div> -->
          </div>
        </v-sheet>
      </v-card>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";

import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');
import { when } from '@/service/Switch';

//import { VueLoading } from 'vue-loading-template';
import { VCalendar } from '@/model/Vuetify/VCalendar';

import { eventModule } from '@/store/dataModules/eventModule';
import LocalDataService from '@/service/LocalDataService';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import { meModule } from '@/store/dataModules/meModule';
// import { familyModule } from '@/store/entityModules/family';

// import { ChildResponse } from '@API/src/component/home/family/types';
// import {
//   DefecationStatus,
//   DefecationStatusType,
// } from '../../node_modules/chaild-entity/src/component/home/defecation/types';

interface Event {
  name: string;
  date: string;
  start: Date;
  end: Date;
  color: string;
  timed: boolean;
  // children: ChildResponse[];
}

interface DataType {
  selectedDate: string;
  selectedEvents: Event[];
  scrollInvoked: number;
  isCalendar: boolean;
  fetchLoading: boolean;
}

export default defineComponent({
  data: (): DataType => ({
    selectedDate: dayjs().format('YYYY-MM-DD'),
    selectedEvents: [],
    scrollInvoked: 0,
    isCalendar: true,
    fetchLoading: false,
  }),

  computed: {
    calendar(): VCalendar {
      return (this.$refs as any).event_calendar;
    },
    events() {
      return eventModule.eventsIncludedDate;
    },
    // children() {
    //   if (familyModule.family) {
    //     return familyModule.family.children;
    //   }
    //   return [];
    // },
    now(): string {
      return dayjs(this.selectedDate).format('YYYY-MM-DD');
    },
    year(): string {
      return dayjs(this.selectedDate).format('YYYY');
    },
    month(): string {
      return dayjs(this.selectedDate).format('M月');
    },
    today(): string {
      return dayjs(this.selectedDate).format('M月D日');
    },
    dayOfTheWeek(): string {
      return dayjs(this.selectedDate).format('ddd');
    },
    dateFormatted(): string {
      return dayjs(this.selectedDate).format('YYYY年MM月DD日（ddd）');
    },
  },

  methods: {
    onScroll(e) {
      this.scrollInvoked = e.target.scrollTop;
      if (this.scrollInvoked > 0) {
        this.isCalendar = false;
      } else {
        this.isCalendar = true;
      }
    },
    toNextMonth() {
      this.selectedDate = dayjs(this.selectedDate)
        .add(1, 'month')
        .format('YYYY-MM-DD');
      sessionStorage.setItem('eventCalendarYM', this.selectedDate);
      this.fetchEvents();
      // tslint:disable-next-line
      // this.calendar.next();
    },
    toPrevMonth() {
      this.selectedDate = dayjs(this.selectedDate)
        .add(-1, 'month')
        .format('YYYY-MM-DD');
      sessionStorage.setItem('eventCalendarYM', this.selectedDate);
      this.fetchEvents();
      // tslint:disable-next-line
      // this.calendar.prev();
    },
    minuteFormat(iso: string) {
      return dayjs(iso).format('HH:mm');
    },
    dateFormat(iso: string) {
      return dayjs(iso).format('D');
    },
    dayFormat(iso: string) {
      return dayjs(iso).format('ddd');
    },
    async fetchEvents() {
      this.fetchLoading = true;
      const fromDate = dayjs(this.selectedDate).startOf('month');
      const endDate = dayjs(this.selectedDate).endOf('month');
      const user = LocalDataService.getUser();
      if (user) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        const nurseryId = nurserySchool.nurseryId;
        await eventModule.fetchEvent({
          nurseryId,
          from: dayjs(fromDate).format('YYYY-MM-DD'),
          to: dayjs(endDate).format('YYYY-MM-DD'),
        });
      }

      this.fetchLoading = false;
    },
    showEvent({ nativeEvent, event }) {
      this.selectedEvents.push(event);
    },
    formatSelectedEvents(): string[] {
      const events: string[] = [];
      if (this.selectedEvents.length) {
        this.selectedDate = dayjs(this.selectedEvents[0].start).format('YYYY-MM-DD');
        for (const s of this.selectedEvents) {
          if (
            dayjs(s.start).format('hh:mm') === '12:00' &&
            dayjs(s.end).format('hh:mm') === '12:00'
          ) {
            events.push(`${s.name}`);
          } else if (s.start && s.end) {
            const from = dayjs(s.start).format('hh:mm');
            const to = dayjs(s.end).format('hh:mm');
            events.push(`${from}-${to} ${s.name}`);
          }
        }
        return events;
      }
      return [];
    },
    viewDay({ date }) {
      this.selectedDate = dayjs(date).format('YYYY-MM-DD');
    },
    getEventNum(date: string) {
      const arr = this.events.filter(e => {
        if (e.date === date) {
          return e;
        }
      });
      return arr;
    },
  },

  async mounted() {
    const eventCalendarYM = sessionStorage.getItem('eventCalendarYM');
    if (eventCalendarYM) this.selectedDate = eventCalendarYM;
    this.fetchEvents();
  },
  beforeUnmount() {
    meModule.setTabIndex('setting')
  },
});
</script>
<style lang="scss" scoped>
@import '../sass/ress.scss';

.wrapper {
  height: 100%;
  overflow-y: scroll;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-width: none;

  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }

  .app_bar {
    @supports (bottom: env(safe-area-inset-bottom)) {
      top: env(safe-area-inset-top);
    }
  }

  .plan-wrapper {
    min-height: 58px;
    border: 1px solid rgb(var(--v-theme-success));
    border-radius: 5px 5px;
  }

  .icon {
    height: 40px;
    width: 40px;

    img {
      height: 100%;
      width: 100%;
      border-radius: 100%;
      object-fit: cover;
    }
  }

  .event_num {
    height: 8px;
    width: 8px;
    background-color: rgb(var(--v-theme-primary));
    border-radius: 100%;
  }
}
</style>
